import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > .fa': {
      margin: theme.spacing(2),
    },
  },
}));

export default function FontAwesomeIconComponent(props) {
  useStyles();

  React.useEffect(() => {
    const existingFontAwesome = document.querySelector('link[data-font-awesome="v5.12.0"]');
    if (existingFontAwesome) {
      return undefined;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://use.fontawesome.com/releases/v5.12.0/css/all.css';
    link.setAttribute('data-font-awesome', 'v5.12.0');
    document.head.appendChild(link);

    return undefined;
  }, []);

  const iconStyle = {
    ...(props.colorName
      ? { color: 'var(--hrms-primary-blue-end, #036dda)' }
      : null),
    ...(props.style || {})
  };

  return (
    <Icon className={props.classes} fontSize={(props.fontSize) ? "small" : ""} style={iconStyle} />
  );
}
